module.exports = __webpack_public_path__ + "img/icon-pnp.127cbfda.png";